const RULES = {
    git: [
        ["Configuraci\u00f3n", /\bgit\s+config\b|git\s+help|git\s+version|git\s+--version/],
        ["Remotos y colaboraci\u00f3n", /\bgit\s+(remote|fetch|pull|push|ls-remote)\b|@\{u\}|--set-upstream|--track/],
        ["Inicializaci\u00f3n y clone", /\bgit\s+(init|clone)\b/],
        ["Ramas", /\bgit\s+(branch|switch|checkout)\b/],
        ["Staging y archivos", /\bgit\s+(add|rm|mv|restore|clean)\b/],
        ["Commits", /\bgit\s+commit\b/],
        ["Merge y rebase", /\bgit\s+(merge|rebase|rerere)\b/],
        ["Stash", /\bgit\s+stash\b/],
        ["Tags y firmas", /\bgit\s+(tag|verify-tag|verify-commit)\b|gpg/],
        ["Historial y b\u00fasqueda", /\bgit\s+(log|show|blame|shortlog|grep|bisect|reflog)\b/],
        ["Diff y patches", /\bgit\s+(diff|apply|format-patch|am|range-diff)\b/],
        ["Subm\u00f3dulos", /\bgit\s+submodule\b/],
        ["Worktrees y sparse", /\bgit\s+(worktree|sparse-checkout)\b/],
        ["Git LFS", /\bgit\s+lfs\b/],
        ["Mantenimiento y diagn\u00f3stico", /\bgit\s+(gc|fsck|maintenance|repack|prune|count-objects)\b/],
        ["Bundles y migraci\u00f3n", /\bgit\s+(bundle|fast-export|fast-import)\b/],
        ["Internals / plumbing", /\bgit\s+(cat-file|hash-object|write-tree|commit-tree|update-ref|symbolic-ref|rev-parse|rev-list|merge-base|verify-pack|show-ref|for-each-ref)\b/],
    ],
    linux: [
        ["Navegaci\u00f3n y archivos", /^(pwd|cd|ls|tree|touch|mkdir|rmdir|cp|mv|rm|ln|realpath|readlink|file|stat|find|locate)\b/],
        ["Permisos y usuarios", /^(chmod|chown|chgrp|umask|id|whoami|groups|useradd|usermod|userdel|groupadd|passwd|su|sudo|getfacl|setfacl)\b/],
        ["Discos y filesystem", /^(df|du|lsblk|blkid|mount|umount|fdisk|parted|mkfs|fsck|sync)\b/],
        ["Procesos y recursos", /^(ps|top|htop|pgrep|pkill|kill|killall|nice|renice|free|uptime|vmstat|iostat|lsof)\b/],
        ["Servicios y logs", /^(systemctl|service|journalctl|dmesg|logger)\b/],
        ["Red y conectividad", /^(ip|ss|netstat|ping|traceroute|tracepath|dig|host|nslookup|curl|wget|nmcli|ethtool|arp)\b/],
        ["Texto y pipelines", /^(cat|less|more|head|tail|grep|sed|awk|cut|paste|sort|uniq|wc|tr|xargs|tee|column|comm|diff)\b/],
        ["Archivos comprimidos", /^(tar|gzip|gunzip|bzip2|xz|zip|unzip|zstd)\b/],
        ["Shell y automatizaci\u00f3n", /^(bash|sh|source|env|export|printenv|alias|unalias|history|crontab|at|watch|time|timeout|nohup)\b/],
        ["Sistema", /^(uname|hostname|hostnamectl|timedatectl|date|cal|lsb_release|cat\s+\/etc\/os-release|reboot|shutdown|poweroff)\b/],
    ],
    cmd: [
        ["Archivos y directorios", /^(dir|cd|chdir|md|mkdir|rd|rmdir|copy|xcopy|robocopy|move|del|erase|ren|rename|type|tree|attrib|where)\b/i],
        ["Procesos y servicios", /^(tasklist|taskkill|sc|net\s+(start|stop)|wmic)\b/i],
        ["Red", /^(ipconfig|ping|tracert|pathping|nslookup|netstat|arp|route|netsh|curl)\b/i],
        ["Sistema y discos", /^(systeminfo|hostname|whoami|ver|chkdsk|diskpart|sfc|dism|driverquery|fsutil)\b/i],
        ["Variables y scripting", /^(set|setx|echo|call|start|choice|for|if|goto|cls|doskey)\b/i],
        ["Registro y seguridad", /^(reg|cipher|icacls|takeown|certutil)\b/i],
    ],
    powershell: [
        ["Archivos y directorios", /\b(Get|Set|New|Remove|Copy|Move|Rename)-(Item|ChildItem|Content)\b|\bTest-Path\b|\bResolve-Path\b|\bJoin-Path\b/],
        ["Procesos y servicios", /\b(Get|Start|Stop|Restart|Wait)-Process\b|\b(Get|Start|Stop|Restart|Set|New)-Service\b/],
        ["Red", /\b(Test-NetConnection|Get-NetTCPConnection|Get-NetIPConfiguration|Get-NetIPAddress|Resolve-DnsName|Invoke-WebRequest|Invoke-RestMethod)\b/],
        ["Remoting", /\b(Enter-PSSession|Exit-PSSession|Invoke-Command|New-PSSession|Remove-PSSession|Enable-PSRemoting|Test-WSMan)\b/],
        ["Objetos y pipeline", /\b(Select-Object|Where-Object|ForEach-Object|Sort-Object|Group-Object|Measure-Object|Tee-Object|Format-Table|Format-List)\b/],
        ["M\u00f3dulos y paquetes", /\b(Get-Module|Import-Module|Remove-Module|Find-Module|Install-Module|Update-Module|Get-InstalledModule)\b/],
        ["Sistema y registro", /\b(Get-ComputerInfo|Get-CimInstance|Get-WmiObject|Get-ItemProperty|Set-ItemProperty|New-ItemProperty|Remove-ItemProperty)\b/],
        ["Seguridad y credenciales", /\b(Get-Credential|ConvertTo-SecureString|ConvertFrom-SecureString|Get-AuthenticodeSignature|Set-AuthenticodeSignature|Get-ExecutionPolicy|Set-ExecutionPolicy)\b/],
        ["Scripting y jobs", /\b(Start-Job|Get-Job|Receive-Job|Wait-Job|Stop-Job|Remove-Job|Register-ScheduledJob|Get-Help|Get-Command)\b/],
    ],
    wsl: [
        ["Instalaci\u00f3n y distribuciones", /wsl\s+(--install|--list|-l|--set-default|--set-version|--update|--unregister)/],
        ["Importar y exportar", /wsl\s+(--import|--export|--import-in-place)/],
        ["Ejecuci\u00f3n e integraci\u00f3n", /wsl\s+(-d|--distribution|--user|-u|--exec|-e)|wslpath|explorer\.exe/],
        ["Sistema y diagn\u00f3stico", /wsl\s+(--status|--version|--shutdown|--terminate)|\/etc\/wsl\.conf|\.wslconfig/],
    ],
    npm: [
        ["Proyecto y scripts", /^npm\s+(init|create|run|run-script|start|stop|restart|test|exec|pkg)\b/],
        ["Dependencias", /^npm\s+(install|i|uninstall|remove|rm|update|outdated|list|ls|explain|dedupe|prune)\b/],
        ["Auditor\u00eda y calidad", /^npm\s+(audit|doctor|fund)\b/],
        ["Configuraci\u00f3n y cache", /^npm\s+(config|cache|prefix|root|bin)\b/],
        ["Registry y publicaci\u00f3n", /^npm\s+(login|logout|whoami|profile|access|owner|team|org|publish|unpublish|deprecate|dist-tag|view|info|pack)\b/],
        ["Versiones y workspaces", /^npm\s+(version|workspace|workspaces|query)\b/],
    ],
    yarn: [
        ["Proyecto y scripts", /^yarn\s+(init|run|start|test|exec|dlx)\b/],
        ["Dependencias", /^yarn\s+(add|remove|up|upgrade|install|why|list|dedupe)\b/],
        ["Workspaces", /^yarn\s+(workspace|workspaces)\b/],
        ["Configuraci\u00f3n y cache", /^yarn\s+(config|cache|set)\b/],
        ["Publicaci\u00f3n y versi\u00f3n", /^yarn\s+(npm|version|pack|publish)\b/],
    ],
    pnpm: [
        ["Proyecto y scripts", /^pnpm\s+(init|create|run|start|test|exec|dlx)\b/],
        ["Dependencias", /^pnpm\s+(add|remove|rm|install|i|update|up|outdated|list|why|prune)\b/],
        ["Workspaces", /^pnpm\s+(-r|--recursive|filter|deploy)\b/],
        ["Store y cache", /^pnpm\s+(store|cache)\b/],
        ["Publicaci\u00f3n y config", /^pnpm\s+(publish|pack|config|setup|env)\b/],
    ],
    node: [
        ["Runtime y ejecuci\u00f3n", /^node\s+(-e|-p|--eval|--print|--watch|--env-file|--run|--test|--check|--input-type|--experimental)/],
        ["Depuraci\u00f3n y profiling", /^node\s+(--inspect|--inspect-brk|--prof|--cpu-prof|--heap-prof|--trace)/],
        ["M\u00f3dulos y resoluci\u00f3n", /^node\s+(--require|-r|--import|--loader|--conditions)/],
        ["Sistema y memoria", /^node\s+(--max-old-space-size|--expose-gc|--v8-options|--report)/],
        ["Corepack y runners", /^(corepack|npx)\b/],
    ],
    typescript: [
        ["Proyecto y configuraci\u00f3n", /^(tsc|npx\s+tsc)\s+(--init|--showConfig|--help|--version)/],
        ["Compilaci\u00f3n", /^(tsc|npx\s+tsc)(\s|$).*?(--project|-p|--outDir|--target|--module|--noEmit|--emitDeclarationOnly)/],
        ["Watch e incremental", /^(tsc|npx\s+tsc).*?(--watch|-w|--incremental|--tsBuildInfoFile)/],
        ["Project references", /^(tsc|npx\s+tsc).*?(--build|-b|--clean|--force|--verbose)/],
        ["Diagn\u00f3stico", /^(tsc|npx\s+tsc).*?(--diagnostics|--extendedDiagnostics|--traceResolution|--listFiles|--explainFiles)/],
    ],
    react: [
        ["Scaffolding", /(create-vite|create-react-app|vite\s+--template|npm\s+create\s+vite)/],
        ["Desarrollo", /(npm|pnpm|yarn)\s+(run\s+)?dev\b|vite\s+--host/],
        ["Build y preview", /(npm|pnpm|yarn)\s+(run\s+)?build\b|vite\s+build|vite\s+preview/],
        ["Testing y calidad", /(test|vitest|eslint|prettier|storybook)/],
        ["Dependencias y tooling", /(npm|pnpm|yarn).*(react|vite|router|query|redux|zustand)/],
    ],
    "react-native": [
        ["Proyecto y setup", /(react-native\s+init|create-expo-app|expo\s+init|expo\s+install)/],
        ["Metro y desarrollo", /(react-native\s+start|expo\s+start|--reset-cache)/],
        ["Android", /(react-native\s+run-android|expo\s+run:android|adb|gradlew.*assemble|gradlew.*bundle)/],
        ["iOS", /(react-native\s+run-ios|expo\s+run:ios|pod\s+install|xcodebuild)/],
        ["EAS build y submit", /^eas\s+(build|submit|update|channel|branch|credentials|device)/],
        ["Diagn\u00f3stico", /(react-native\s+doctor|expo\s+doctor|expo-env-info)/],
    ],
    nest: [
        ["Proyecto y generaci\u00f3n", /^nest\s+(new|generate|g)\b/],
        ["Desarrollo y build", /^nest\s+(start|build)\b/],
        ["Monorepo y librer\u00edas", /^nest\s+(generate\s+(app|library)|g\s+(app|lib))\b/],
        ["Info y mantenimiento", /^nest\s+(info|update|add)\b/],
        ["Testing y scripts", /^(npm|pnpm|yarn).*(test|e2e|lint|migration)/],
    ],
    docker: [
        ["Contenedores", /^docker\s+(run|create|start|stop|restart|kill|rm|rename|wait|pause|unpause)\b/],
        ["Im\u00e1genes", /^docker\s+(images|image|pull|push|rmi|tag|save|load|history|inspect)\b/],
        ["Build y Buildx", /^docker\s+(build|buildx)\b/],
        ["Logs, exec y debug", /^docker\s+(logs|exec|attach|top|stats|diff|cp|port)\b/],
        ["Redes", /^docker\s+network\b/],
        ["Vol\u00famenes", /^docker\s+volume\b/],
        ["Registry y auth", /^docker\s+(login|logout|trust)\b/],
        ["Sistema y limpieza", /^docker\s+(system|info|version|events|prune)\b/],
        ["Contextos y remotos", /^docker\s+context\b/],
    ],
    compose: [
        ["Lifecycle", /^docker\s+compose\s+(up|down|start|stop|restart|pause|unpause|kill)\b/],
        ["Servicios y debugging", /^docker\s+compose\s+(ps|logs|exec|run|top|port|events|wait)\b/],
        ["Build e im\u00e1genes", /^docker\s+compose\s+(build|pull|push|images)\b/],
        ["Configuraci\u00f3n", /^docker\s+compose\s+(config|convert|profiles|ls)\b/],
        ["Escalado y recursos", /^docker\s+compose\s+(up.*--scale|create|rm|cp)\b/],
    ],
    kubernetes: [
        ["Contextos y configuraci\u00f3n", /^kubectl\s+config\b|^kubectl\s+(cluster-info|api-resources|api-versions|version)\b/],
        ["Pods y debugging", /^kubectl\s+(get\s+pods|describe\s+pod|logs|exec|attach|port-forward|debug|cp|top\s+pod)\b/],
        ["Deployments y rollouts", /^kubectl\s+(get\s+deploy|create\s+deployment|set\s+image|rollout|scale|autoscale)\b/],
        ["Services e ingress", /^kubectl\s+(get\s+(svc|service|ingress)|expose|create\s+(service|ingress))\b/],
        ["ConfigMaps y Secrets", /^kubectl\s+(create|get|describe|delete).*?(configmap|secret)\b/],
        ["Storage", /^kubectl\s+(get|describe|delete).*?(pv|pvc|storageclass)\b/],
        ["Nodos y mantenimiento", /^kubectl\s+(get\s+nodes|describe\s+node|cordon|uncordon|drain|taint|top\s+node)\b/],
        ["RBAC y seguridad", /^kubectl\s+(auth|create\s+(role|clusterrole|rolebinding|clusterrolebinding|serviceaccount))\b/],
        ["Manifiestos y recursos", /^kubectl\s+(apply|create|replace|patch|edit|delete|diff|wait|label|annotate)\b/],
    ],
    terraform: [
        ["Init y providers", /^terraform\s+(init|providers|get)\b/],
        ["Plan, apply y destroy", /^terraform\s+(plan|apply|destroy|refresh)\b/],
        ["Formato y validaci\u00f3n", /^terraform\s+(fmt|validate|test)\b/],
        ["State", /^terraform\s+state\b|^terraform\s+(import|taint|untaint)\b/],
        ["Workspaces", /^terraform\s+workspace\b/],
        ["Outputs e inspecci\u00f3n", /^terraform\s+(output|show|console|graph|version)\b/],
        ["Cloud y login", /^terraform\s+(login|logout|cloud)\b/],
    ],
    aws: [
        ["Auth y configuraci\u00f3n", /^aws\s+(configure|sts|sso)\b/],
        ["S3", /^aws\s+s3\b|^aws\s+s3api\b/],
        ["EC2", /^aws\s+ec2\b/],
        ["ECR y ECS", /^aws\s+(ecr|ecs)\b/],
        ["Lambda", /^aws\s+lambda\b/],
        ["CloudFormation", /^aws\s+cloudformation\b/],
        ["Logs y monitoreo", /^aws\s+(logs|cloudwatch)\b/],
        ["IAM y seguridad", /^aws\s+(iam|secretsmanager|ssm|kms)\b/],
        ["RDS y datos", /^aws\s+(rds|dynamodb)\b/],
    ],
    github: [
        ["Autenticaci\u00f3n y config", /^gh\s+(auth|config|status|version)\b/],
        ["Repositorios", /^gh\s+repo\b/],
        ["Pull requests", /^gh\s+pr\b/],
        ["Issues", /^gh\s+issue\b/],
        ["Releases", /^gh\s+release\b/],
        ["Actions y workflows", /^gh\s+(workflow|run|cache|secret|variable)\b/],
        ["API y extensiones", /^gh\s+(api|extension|alias)\b/],
        ["Codespaces", /^gh\s+codespace\b/],
        ["Gists", /^gh\s+gist\b/],
    ],
    ssh: [
        ["Conexi\u00f3n", /^ssh\b(?!-(keygen|add|agent|copy-id|keyscan))/],
        ["Claves y agente", /^ssh-(keygen|add|agent|copy-id)\b/],
        ["Known hosts", /^ssh-keyscan\b|known_hosts|ssh-keygen\s+-R/],
        ["Transferencia", /^(scp|sftp|rsync)\b/],
        ["T\u00faneles y port forwarding", /^ssh\b.*\s(-L|-R|-D|-J)\b/],
        ["Config y diagn\u00f3stico", /^ssh\b.*(-F|-G|-v|-vv|-vvv)|~\/\.ssh\/config/],
    ],
    curl: [
        ["Requests b\u00e1sicos", /^curl\b.*\s(-X|--request)?\s*(GET|HEAD)?\b|^curl\s+https?:/],
        ["Headers y auth", /^curl\b.*(-H|--header|-u|--user|--oauth2-bearer|Authorization)/],
        ["Body y uploads", /^curl\b.*(-d|--data|-F|--form|-T|--upload-file)/],
        ["Downloads y salida", /^curl\b.*(-o|--output|-O|--remote-name|--remote-header-name)/],
        ["TLS y certificados", /^curl\b.*(-k|--insecure|--cacert|--cert|--key|--tls)/],
        ["Redirects, retry y timeouts", /^curl\b.*(-L|--location|--retry|--max-time|--connect-timeout)/],
        ["Proxy y red", /^curl\b.*(--proxy|-x|--resolve|--connect-to|--interface|--ipv4|--ipv6)/],
        ["Diagn\u00f3stico", /^curl\b.*(-v|--verbose|-w|--write-out|--trace|--trace-ascii)/],
    ],
    postgres: [
        ["Conexi\u00f3n y sesi\u00f3n", /^(psql|\\conninfo|\\c\b|\\connect|\\q|\\password)/],
        ["Schema e inspecci\u00f3n", /^(\\d|\\dt|\\dn|\\df|\\dv|\\di|\\l|\\du|\\x|\\timing|\\pset)/],
        ["Backup y restore", /^(pg_dump|pg_dumpall|pg_restore)\b/],
        ["Administraci\u00f3n", /^(createdb|dropdb|createuser|dropuser|vacuumdb|reindexdb|clusterdb)\b/],
        ["Importar y exportar", /^(\\copy|COPY\b)/i],
        ["Diagn\u00f3stico y performance", /^(EXPLAIN|ANALYZE|VACUUM|REINDEX|pg_isready|pgbench)\b/i],
        ["Replicaci\u00f3n", /^(pg_basebackup|pg_receivewal|pg_recvlogical)\b/],
    ],
    mysql: [
        ["Conexi\u00f3n", /^(mysql|mariadb)\b/],
        ["Schema e inspecci\u00f3n", /^(SHOW|DESCRIBE|DESC|USE)\b/i],
        ["Backup y restore", /^(mysqldump|mysqlpump|mariadb-dump|mysql\s+.*<)/],
        ["Usuarios y seguridad", /^(CREATE\s+USER|ALTER\s+USER|DROP\s+USER|GRANT|REVOKE)\b/i],
        ["Administraci\u00f3n", /^(mysqladmin|mysqlcheck|mysql_upgrade|mariadb-admin)\b/],
        ["Diagn\u00f3stico", /^(EXPLAIN|SHOW\s+PROCESSLIST|SHOW\s+ENGINE|SHOW\s+STATUS)\b/i],
    ],
    redis: [
        ["Conexi\u00f3n y servidor", /^redis-cli\b.*(PING|INFO|CONFIG|CLIENT|COMMAND|MONITOR|SLOWLOG)?/],
        ["Keys", /^redis-cli\b.*\s(GET|SET|DEL|EXISTS|EXPIRE|TTL|SCAN|KEYS|TYPE|RENAME|UNLINK)\b/],
        ["Hashes y colecciones", /^redis-cli\b.*\s(HGET|HSET|HGETALL|LPUSH|RPUSH|LRANGE|SADD|SMEMBERS|ZADD|ZRANGE)\b/],
        ["Pub/Sub y streams", /^redis-cli\b.*\s(PUBLISH|SUBSCRIBE|PSUBSCRIBE|XADD|XREAD|XGROUP|XACK)\b/],
        ["Persistencia y backup", /^redis-cli\b.*\s(BGSAVE|SAVE|LASTSAVE|BGREWRITEAOF)\b|redis-check-(rdb|aof)/],
        ["Cluster y replicaci\u00f3n", /^redis-cli\b.*\s(CLUSTER|REPLICAOF|ROLE|SENTINEL)\b|--cluster/],
    ],
    python: [
        ["Runtime y scripts", /^python(3)?\b.*(-c|-m|-i|-V|--version|script|\.py)/],
        ["Entornos virtuales", /^python(3)?\s+-m\s+venv\b|^(source|\.\\).*activate|deactivate/],
        ["pip y paquetes", /^(pip|pip3|python\s+-m\s+pip|python3\s+-m\s+pip)\b/],
        ["Testing", /^(pytest|python\s+-m\s+unittest|coverage)\b/],
        ["Lint y formato", /^(ruff|black|isort|flake8|mypy|pyright)\b/],
        ["Packaging", /^(python\s+-m\s+build|twine|pipx|poetry|uv)\b/],
        ["Profiling y debug", /^(python\s+-m\s+(cProfile|pdb|trace|timeit)|py-spy)\b/],
    ],
    network: [
        ["Conectividad", /^(ping|tracert|traceroute|pathping|tracepath|mtr)\b/],
        ["DNS", /^(nslookup|dig|host|Resolve-DnsName)\b/],
        ["Puertos y sockets", /^(netstat|ss|lsof|Get-NetTCPConnection|Test-NetConnection|nc|ncat|telnet)\b/],
        ["Interfaces y rutas", /^(ipconfig|ip\b|ifconfig|route|Get-NetIPConfiguration|Get-NetRoute|nmcli)\b/],
        ["HTTP y TLS", /^(curl|wget|openssl\s+s_client)\b/],
        ["Captura y diagn\u00f3stico", /^(tcpdump|tshark|wireshark|arp|ethtool)\b/],
    ],
    processes: [
        ["Windows", /^(tasklist|taskkill|Get-Process|Stop-Process|Get-NetTCPConnection)\b/],
        ["Linux", /^(ps|top|htop|pgrep|pkill|kill|killall|nice|renice|lsof|fuser)\b/],
        ["Puertos", /(netstat|ss|lsof|Get-NetTCPConnection|fuser)/],
        ["Recursos", /(top|htop|free|vmstat|iostat|Get-Counter|Measure-Object)/],
    ],
    packages: [
        ["Windows winget", /^winget\b/],
        ["Chocolatey", /^choco\b/],
        ["Scoop", /^scoop\b/],
        ["Debian / Ubuntu", /^(apt|apt-get|dpkg)\b/],
        ["Fedora / RHEL", /^(dnf|yum|rpm)\b/],
        ["Arch Linux", /^(pacman|yay)\b/],
        ["macOS Homebrew", /^(brew|mas)\b/],
        ["Snap / Flatpak", /^(snap|flatpak)\b/],
    ],
    go: [
        ["Proyecto y m\u00f3dulos", /^go\s+(mod|work)\b/],
        ["Build y ejecuci\u00f3n", /^go\s+(run|build|install|generate)\b/],
        ["Testing y cobertura", /^go\s+(test|tool\s+cover)\b/],
        ["Dependencias", /^go\s+(get|list|mod\s+(tidy|download|vendor|graph|why))\b/],
        ["Diagn\u00f3stico", /^go\s+(env|version|vet|doc|tool)\b/],
    ],
    rust: [
        ["Proyecto y build", /^cargo\s+(new|init|build|run|check)\b/],
        ["Dependencias", /^cargo\s+(add|remove|update|tree|vendor|fetch)\b/],
        ["Testing y calidad", /^cargo\s+(test|bench|clippy|fmt)\b/],
        ["Publicaci\u00f3n", /^cargo\s+(package|publish|yank|login|owner)\b/],
        ["Toolchain", /^(rustup|cargo\s+(install|uninstall|metadata|doc))\b/],
    ],
    dotnet: [
        ["Proyecto y solution", /^dotnet\s+(new|sln)\b/],
        ["Build y ejecuci\u00f3n", /^dotnet\s+(build|run|watch|publish|clean)\b/],
        ["Paquetes", /^dotnet\s+(add|remove|list).*package|^dotnet\s+nuget\b/],
        ["Testing", /^dotnet\s+test\b/],
        ["EF Core", /^dotnet\s+ef\b/],
        ["Tooling", /^dotnet\s+(tool|workload|sdk|restore|format)\b/],
    ],
    java: [
        ["Java runtime", /^(java|javac|jar|javadoc|jshell|jcmd|jps|jstack|jmap|jstat)\b/],
        ["Maven", /^(mvn|mvnw)\b/],
        ["Gradle", /^(gradle|gradlew)\b/],
        ["Testing y quality", /(test|checkstyle|spotbugs|jacoco)/],
        ["Dependencias y build", /(dependency|dependencies|package|assemble|build|clean)/],
    ],
    php: [
        ["Runtime", /^php\b/],
        ["Composer", /^composer\b/],
        ["Laravel Artisan", /^php\s+artisan\b/],
        ["Symfony Console", /^php\s+bin\/console\b/],
        ["Testing y calidad", /^(phpunit|pest|phpstan|psalm|php-cs-fixer)\b/],
    ],
    android: [
        ["ADB dispositivos", /^adb\s+(devices|connect|disconnect|pair|get-state|shell|get-serialno)\b/],
        ["Apps y paquetes", /^adb\s+(install|uninstall|shell\s+pm|shell\s+am)\b/],
        ["Logs y debug", /^adb\s+(logcat|bugreport|shell\s+dumpsys)\b/],
        ["Archivos", /^adb\s+(push|pull|sync)\b/],
        ["Emulador y SDK", /^(emulator|sdkmanager|avdmanager)\b/],
        ["Gradle Android", /gradlew.*(assemble|bundle|install|lint|test)/],
    ],
    nginx: [
        ["Configuraci\u00f3n", /^nginx\s+(-t|-T|-V|-v|-s)/],
        ["Servicio", /systemctl\s+(start|stop|restart|reload|status).*nginx|service\s+nginx/],
        ["Sites y proxy", /(sites-available|sites-enabled|proxy_pass|server_name)/],
        ["Logs", /(access\.log|error\.log|tail.*nginx)/],
        ["TLS", /(ssl_certificate|certbot.*nginx)/],
    ],
    openssl: [
        ["Certificados X.509", /^openssl\s+x509\b/],
        ["Claves", /^openssl\s+(genpkey|genrsa|pkey|rsa|ecparam|ec)\b/],
        ["CSR y CA", /^openssl\s+(req|ca)\b/],
        ["TLS remoto", /^openssl\s+s_(client|server)\b/],
        ["Hashes y encoding", /^openssl\s+(dgst|sha|base64|enc|rand)\b/],
        ["PKCS", /^openssl\s+(pkcs12|pkcs7|pkcs8)\b/],
    ],
    jq: [
        ["Selecci\u00f3n", /^jq\b.*(\.|select\(|has\(|type)/],
        ["Arrays", /^jq\b.*(map\(|sort_by\(|group_by\(|unique|flatten|length)/],
        ["Objetos", /^jq\b.*(keys|to_entries|from_entries|with_entries|del\()/],
        ["Transformaci\u00f3n", /^jq\b.*(--arg|--argjson|@csv|@tsv|@json|reduce|walk)/],
        ["Entrada y salida", /^jq\b.*(-r|-c|-s|-n|--stream|--slurpfile)/],
    ],
    "text-utils": [
        ["grep", /^grep\b|^rg\b/],
        ["sed", /^sed\b/],
        ["awk", /^awk\b/],
        ["cut / sort / uniq", /^(cut|sort|uniq|paste|join|comm)\b/],
        ["xargs y pipelines", /^(xargs|tee|tr|wc|column)\b/],
    ],
    helm: [
        ["Repositorios", /^helm\s+repo\b/],
        ["Charts", /^helm\s+(create|package|lint|template|show|pull|dependency)\b/],
        ["Releases", /^helm\s+(install|upgrade|uninstall|list|status|history|rollback|get|test)\b/],
        ["Values y diff", /^helm\s+.*(-f|--values|--set)|helm\s+get\s+values|helm\s+diff/],
        ["Registry OCI", /^helm\s+(registry|push|pull).*oci/],
    ],
    ansible: [
        ["Inventario", /^ansible-inventory\b|^ansible\b.*--list-hosts/],
        ["Ad-hoc", /^ansible\b/],
        ["Playbooks", /^ansible-playbook\b/],
        ["Vault", /^ansible-vault\b/],
        ["Galaxy y collections", /^ansible-galaxy\b/],
        ["Config y diagn\u00f3stico", /^ansible-(config|doc|console|pull)\b/],
    ],
    make: [
        ["Targets", /^make\b.*(-f|--file)?/],
        ["Paralelismo", /^make\b.*(-j|--jobs|--load-average)/],
        ["Dry-run y debug", /^make\b.*(-n|--just-print|-d|--debug|-p|--print-data-base)/],
        ["Variables", /^make\b.*[A-Z_]+=|^make\b.*(-e|--environment-overrides)/],
    ],
    "azure-cli": [
        ["Auth y cuenta", /^az\s+(login|logout|account|config|cloud)\b/],
        ["Resource Groups", /^az\s+group\b/],
        ["Compute", /^az\s+(vm|vmss)\b/],
        ["Storage", /^az\s+storage\b/],
        ["Containers", /^az\s+(acr|aks|containerapp|container)\b/],
        ["Web y Functions", /^az\s+(webapp|functionapp)\b/],
        ["Key Vault y seguridad", /^az\s+(keyvault|ad|role)\b/],
        ["Monitor", /^az\s+monitor\b/],
    ],
    gcloud: [
        ["Auth y config", /^gcloud\s+(auth|config|info|version)\b/],
        ["Compute", /^gcloud\s+compute\b/],
        ["Cloud Run", /^gcloud\s+run\b/],
        ["GKE", /^gcloud\s+container\b/],
        ["Storage", /^(gcloud\s+storage|gsutil)\b/],
        ["Functions", /^gcloud\s+functions\b/],
        ["IAM y secrets", /^gcloud\s+(iam|secrets|projects\s+get-iam-policy|projects\s+add-iam-policy-binding)\b/],
        ["Logs", /^gcloud\s+logging\b/],
    ],
    systemd: [
        ["Servicios", /^systemctl\s+(start|stop|restart|reload|status|enable|disable|mask|unmask|is-active|is-enabled)\b/],
        ["Units", /^systemctl\s+(list-units|list-unit-files|cat|edit|show|set-property|daemon-reload)\b/],
        ["Timers", /^systemctl\s+list-timers|systemd-analyze\s+calendar/],
        ["Logs", /^journalctl\b/],
        ["Boot y diagn\u00f3stico", /^systemd-analyze\b|systemctl\s+(default|rescue|emergency|reboot|poweroff)/],
    ],
};

const TOPIC_ALIASES = {
    "Administracion": "Administración",
    "Conexion": "Conexión",
    "Configuracion": "Configuración",
    "Diagnostico": "Diagnóstico",
    "Ejecucion remota": "Ejecución remota",
    "Gestion": "Gestión",
    "Imagenes": "Imágenes",
    "Instalacion y version": "Instalación y versión",
    "Contextos y configuracion": "Contextos y configuración",
    "Preparacion servidor": "Preparación servidor",
    "Preparacion release": "Preparación release",
    "Renovacion": "Renovación",
    "Plugins y diagnostico": "Plugins y diagnóstico",
    "Sistema y version": "Sistema y versión",
    "Volumenes": "Volúmenes",
    "Auth": "Auth y proyecto",
    "Environments": "Entornos y servicios",
};

const CATEGORY_TOPIC_ALIASES = {
    wsl: {
        "Distribuciones": "Instalación y distribuciones",
        "Ejecución": "Ejecución e integración",
        "Sistema": "Sistema y diagnóstico",
    },
    railway: {
        "Debug": "Ejecución remota",
    },
    certbot: {
        "Obtener certificado": "Emisión",
        "Renovación": "Renovación",
        "Diagnóstico": "Plugins y diagnóstico",
    },
};

const normalizeTopic = (categoryId, topic) => {
    const categoryAlias = CATEGORY_TOPIC_ALIASES[categoryId]?.[topic];
    if (categoryAlias) return categoryAlias;
    return TOPIC_ALIASES[topic] || topic;
};

const DEFAULT_BY_CATEGORY = {
    react: "Tooling", nest: "CLI y proyecto", node: "Runtime", typescript: "Compiler",
    compose: "Docker Compose", kubernetes: "Recursos", terraform: "Terraform",
    aws: "AWS CLI", github: "GitHub CLI", postgres: "PostgreSQL", mysql: "MySQL / MariaDB",
    redis: "Redis CLI", python: "Python", packages: "Gestores de paquetes", java: "Java / build tools",
};

export const resolveCommandTopic = (categoryId, item) => {
    if (item?.topic) return normalizeTopic(categoryId, item.topic);
    const command = String(item?.command || "");
    const rules = RULES[categoryId] || [];
    const match = rules.find(([, regex]) => regex.test(command));
    return match?.[0] || DEFAULT_BY_CATEGORY[categoryId] || "General";
};

export const getCategoryTopics = (category) => {
    if (!category) return [];
    return [...new Set((category.commands || []).map((item) => resolveCommandTopic(category.id, item)).filter(Boolean))];
};
